import MoneyInput from 'components/MoneyInput';
import React from 'react';
import {
  calculateNewBaseMarginPercentW2,
  getInheritedSettings,
  getSourceAndLabel,
} from '../PositionRateSettingsForm.utils';
import { useFormContext } from 'react-hook-form';
import { DisplayHelpers } from 'utils/helpers';

type Props = {
  source: string;
  inheritedSettings: any;
};

export const ProfessionalRateInput = ({ source, inheritedSettings }: Props) => {
  const { watch, setValue } = useFormContext();
  const isW2Local = source.includes('w2.local');

  const { field } = getSourceAndLabel(source);

  const mergedSettings = getInheritedSettings({ source, inheritedSettings, watch });

  const { use_blended_rate, charge_rate_cents, blended_rate_cents } = mergedSettings;

  function onChangeProfessionalRate(event: React.FocusEvent<HTMLInputElement>) {
    const professionalRate = DisplayHelpers.stringToCents(event.target.value);
    let rateCents = charge_rate_cents;

    if (use_blended_rate) {
      rateCents = blended_rate_cents;
    }

    const newMargin = (1 - professionalRate / rateCents).toFixed(5);

    setValue(`${source}.${field}`, newMargin);

    if (isW2Local) {
      calculateNewBaseMarginPercentW2({
        setValue,
        source,
        watch,
        totalMarginPercentW2: Number(newMargin),
      });
    }
  }

  return (
    <MoneyInput
      source={`${source}.pro_rate_cents`}
      label="Professional Rate"
      onChange={onChangeProfessionalRate}
    />
  );
};
